import type { JSX, VoidComponent } from "solid-js";
import { splitProps } from "solid-js";

type ButtonLinkProps = {
  label: string | JSX.Element;
} & JSX.HTMLAttributes<HTMLButtonElement>;

const ButtonLink: VoidComponent<ButtonLinkProps> = (props) => {
  const [localProps, otherProps] = splitProps(props, ["label"]);

  return (
    <button
      class="text-left text-link underline hover:text-link-hover focus-visible:outline-default"
      type="button"
      {...otherProps}
    >
      {localProps.label}
    </button>
  );
};

export default ButtonLink;
